import { compose, head, prop, split } from 'ramda'
import queryString from 'query-string'

export const forceAppendQueryParams = (value, label) => {
  const loc = window.location
  const url = new URL(loc.href)
  url.searchParams.append(value, label)
  window.location = url
}

export const prepareQueryParams = (key, value) => {
  const qp = getQueryParams()
  qp[key] = value
  return queryString.stringify(qp)
}

export const prepareJsonQueryParams = (key, value) => {
  try {
    const jsonValue = JSON.stringify(value)
    return prepareQueryParams(key, jsonValue)
  } catch (e) {
    return prepareQueryParams(key, undefined)
  }
}

// export const setQueryParams = (key, value) => {
// const params = prepareQueryParams(key, value)
// window.location.search = params
// history.replaceState(null, null, '?' + params)
// }

export const getJsonQueryParam = key => {
  try {
    return compose(JSON.parse, getQueryParam)(key)
  } catch {
    return undefined
  }
}

export const getQueryParam = key => {
  const qp = getQueryParams(key)
  return prop(key, qp)
}

export const getQueryParams = () => {
  const loc = window.location
  return queryString.parse(loc.search) || {}
}

export const getSubdomain = () => {
  const loc = window.location
  return compose(head, split('.'))(loc.hostname)
}
